module.exports = __webpack_public_path__ + "media/images/emblems/Bichelsee-Balterswil-Blazono-539bdf52eca56e38828ed0cef805eaf1.png";